import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import Cards1 from './../block/Cards1'
import Raschet from './../block/Raschet'
import Team from './../block/Team'
import Kontakti from './../block/Kontakti'
import PhotoGallarySlyder from './../block/PhotoGallarySlyder'

class Ozavode extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
          video={true}
        />
        <Cards1
          list={data?.circlecards2?.list || []}
          margin={`bottom-26`}
          cols={`1`}
          layout={10}
        />
        <Cards1
          list={data?.circlecards1?.list || []}
          margin={`bottom`}
          cols={`2`}
          layout={11}
          bg={`2`}
        />
        <Cards1
          list={data?.circlecards3?.list || []}
          title={`Этапы <span>производства</span>`}
          text={`Все процессы на нашем предприятии выполняются чётко и качественно. Кроме того, мы внедряем новые технологии, которые позволяют нам повышать производительность и удовлетворять потребности всех клиентов с высокой гарантией качества.`}
          margin={`bottom`}
          cols={`etapi-4`}
          layout={2}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
          variant={`zavod`}
        />
        <Team
          data={data?.team || {}}
          margin={`top`}
        />
        <PhotoGallarySlyder
          data={data?.photogallary || {}}
          margin={`top`}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

Ozavode.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Ozavode.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Ozavode